<style>
	:global(body.dark-mode) .menu-list a {
		color: white;
	}
    :global(body.dark-mode) .menu-list a:hover {
        background-color: #161b22 !important;
    }
</style>

<aside class="menu">
    <p class="menu-label">Search in</p>
    <ul class="menu-list">
        <li><a href="#events">Events</a></li>
        <li><a href="#conditions">Conditions</a></li>
        <li><a href="#effects">Effects</a></li>
        <li><a href="#expressions">Expressions</a></li>
    </ul>
</aside>